import React from 'react';
import type { FormRule } from 'antd';
import { Form, Select } from 'antd';
import classNames from 'classnames';
import type { TransportRes } from 'api/swagger';
import { createLabel } from './create-label';
import styles from './transport-form-select.module.scss';

const { Option } = Select;

interface ITransportFormSelectProps {
  name: string | Array<string | number>;
  placeholder?: string;
  className?: string;
  rootClassName?: string;
  rules?: FormRule[];
  transports?: TransportRes[];
  disabled?: boolean;
}

export const TransportFormSelect: React.FC<ITransportFormSelectProps> = (props) => {
  const { name, rules, placeholder, className, rootClassName, transports, disabled } = props;

  return (
    <Form.Item name={name} className={className} rootClassName={rootClassName} rules={rules}>
      <Select optionFilterProp='label' placeholder={placeholder} disabled={disabled} showSearch allowClear>
        {transports?.map((transport: TransportRes) => {
          const label = createLabel({
            plateNumber: transport.plateNumber,
            subType: transport.subType,
            needService: transport.needService,
            inService: transport.inService,
          });
          return (
            <Option
              key={transport.id}
              value={transport.id}
              label={label}
              className={classNames({ [styles.strikethrough]: transport.inService })}>
              {label}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};
